import {
  AbstractControl,
  FormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export function uniqueRuleListAttribute(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const attributeName = control.value as string;
    const formControls = formArray.controls
      .map((formGroup) => formGroup.get('attribute'))
      .filter((formControl) => formControl !== control);

    if (attributeName && formControls?.length) {
      const existingAttr = formControls.map((c) => c?.value);
      return existingAttr.indexOf(attributeName) > -1 ? {unique: true} : null;
    } else {
      return null;
    }
  };
}
